import initialiseZoom from '../components/productZoom';
import { initPDPSlider } from '../dom/glidify';
import { onShopifySectionLoad, ready } from '../global/instantiate';
import { productInit } from '../sections/product';
import { initClickToViewGallery } from '../sections/productImagesZoom';
import { initProductUpsell } from '../sections/productUpsell';
import '../sections/product/closer-look'
import '../sections/product/closer-look-features'
import '../sections/product/product-sticky-form'

export const pdpInit = () => {

  if(document.querySelector('[data-description-read-more]')) {
    document.querySelector('[data-description-read-more]').addEventListener('click', () => {
      document.querySelector('.section-product_description').scrollIntoView({
        behavior: 'smooth'
      })
    });
  }

  // bundle-builder redirect functionality
  const bundleLink = document.querySelector('.template-product #bundle-builder-app--bundle-link');
  if (bundleLink) { 
    bundleLink.click();
  }

  initClickToViewGallery()
  initProductUpsell();
  productInit({}, (variant) => {
    if (!variant) return;

    const productSkuElement = document.querySelector('[data-product-sku]');
    const productForm = document.querySelector('[data-product-form]');
    const productFormSubmit = productForm.querySelector('[data-product-form-submit]');
    //switch StockDisplay sets the value
    productFormSubmit.textContent = productFormSubmit.value;
    if (productForm.querySelector('.pre-order.container') !== null) {
      if (productForm.dataset.productInStock === 'pre-order') {
        productForm.querySelector('.pre-order.container').classList.remove('hide');
      } else {
        productForm.querySelector('.pre-order.container').classList.add('hide');
      }
    }

    if (productSkuElement) {
      const productSkuText = productSkuElement.dataset.text.replace('{{ sku }}', variant.sku);
      productSkuElement.textContent = productSkuText;
    }

    // For single image product template only!!
    const imgContainer = document.querySelector('[data-variant-images]');
    if (imgContainer) {
      const struct = imgContainer.dataset.variantImages;

      if (struct) {
        // The struct will look something like: "POSITION_1||IMG_URL_1||IMG_SRCSET_1||VARIANT_ID_1,POSITION_2||IMG_URL_2||IMG_SRCSET_2||VARIANT_ID_2"
        // So we will split it by comma and double pipe to get the image for this variant
        const imageSets = struct.split(',');
        if (imageSets) {
          const imageSet = imageSets.map(imageSet => imageSet.split('||'))
            .filter(set => Number.parseInt(set[0]) === variant.id);
          const img = imgContainer.querySelector('img');

          if (imageSet.length) {
            img.setAttribute('src', imageSet[0][1]);
            img.setAttribute('srcset', imageSet[0][2]);
            imgContainer.setAttribute('data-image-index', imageSet[0][3]);
          }
        }
      }
    }
  });
  initPDPSlider();
  initClickToViewGallery();
  initialiseZoom('[data-main-product-image-wrapper]', 2);
};

ready(() => {
  pdpInit();
});

onShopifySectionLoad(() => {
  pdpInit();
});
